import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const IconAgency = ({ fontSize = 24, ...other }) => {
  const theme = useTheme();

  return (
    <Box component="span" display="block" {...other}>
      <svg width={fontSize} height={fontSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 21V3H12V7H22V21H2ZM5.01548 21H9V17H5L5.01548 21ZM4 15H6V13H4V15ZM4 11H6V9H4V11ZM4 7H6V5H4V7ZM8 15H10V13H8V15ZM8 11H10V9H8V11ZM8 7H10V5H8V7ZM12 19H20V9H12V11H14V13H12V15H14V17H12V19ZM16 13V11H18V13H16ZM16 17V15H18V17H16Z"
          fill={theme.palette.text.secondary}
        />
      </svg>
    </Box>
  );
};

IconAgency.propTypes = {
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconAgency;
